const MINIMIZE_EVENT = 'vc:minimize-panel';
const OPEN_ASSISTANCE_EVENT = 'vc:open-assistance';
const TABLE_APPROVED_EVENT = 'vc:table-approved';
const TABLE_REQUESTED_EVENT = 'vc:table-requested';
const QUEUE_UPDATED_EVENT = 'vc:queue-updated';

/** Collapse the expanded Peppy AI chat so the page behind is visible. */
export function requestCaptainPanelMinimize(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MINIMIZE_EVENT));
}

/** Open the Peppy AI panel on the Assistance tab (quick requests + call captain). */
export function requestCaptainAssistanceOpen(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_ASSISTANCE_EVENT));
}

export function notifyCaptainTableApproved(tableNumber: number): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TABLE_APPROVED_EVENT, { detail: { tableNumber } }));
}

export function notifyCaptainTableRequested(tableNumber: number, allotted: boolean): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(TABLE_REQUESTED_EVENT, { detail: { tableNumber, allotted } })
  );
}

export function notifyCaptainQueueUpdated(detail: {
  tokenLabel?: string;
  status?: string;
  position?: number;
}): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(QUEUE_UPDATED_EVENT, { detail }));
}

export const CAPTAIN_PANEL_MINIMIZE_EVENT = MINIMIZE_EVENT;
export const CAPTAIN_ASSISTANCE_OPEN_EVENT = OPEN_ASSISTANCE_EVENT;
export const CAPTAIN_TABLE_APPROVED_EVENT = TABLE_APPROVED_EVENT;
export const CAPTAIN_TABLE_REQUESTED_EVENT = TABLE_REQUESTED_EVENT;
export const CAPTAIN_QUEUE_UPDATED_EVENT = QUEUE_UPDATED_EVENT;
